import React, { useState } from 'react';
import { Card, Table, Form, Badge, Row, Col } from 'react-bootstrap';
import { useQuery } from 'react-query';
import moment from 'moment';
import { LOPDAOTAOLIENTUC_TRIENKHAI_API } from '../../../../utils/apiUrl';
import { Get } from '../../../../utils/httpProvider';

const StudentLienTucTab = ({ lopId }) => {
    const [keyword, setKeyword] = useState('');

    const { data: studentsData = [], isLoading } = useQuery(
        ['studentsLienTuc', lopId],
        () => Get(`${LOPDAOTAOLIENTUC_TRIENKHAI_API.GET_HOCVIENS}/${lopId}`),
        {
            enabled: !!lopId,
            select: (res) => res?.$values || res || []
        }
    );

    const filteredStudents = studentsData.filter(s => {
        if (!keyword) return true;
        const key = keyword.toLowerCase().trim();
        return (
            (s.hoTen && s.hoTen.toLowerCase().includes(key)) ||
            (s.soDienThoai && s.soDienThoai.includes(key)) ||
            (s.soCccd && s.soCccd.includes(key))
        );
    });

    const getGioiTinhBadge = (gt) => {
        if (gt === 1) return <Badge variant="info">Nam</Badge>;
        if (gt === 2) return <Badge variant="danger">Nữ</Badge>;
        return <Badge variant="secondary">Khác</Badge>;
    };

    return (
        <Card className="shadow-sm border-0">
            <Card.Header className="bg-white py-3">
                <Row className="align-items-center justify-content-between">
                    <Col md={6}>
                        <h6 className="mb-0 text-primary font-weight-bold">
                            <i className="fas fa-user-graduate mr-2"></i>
                            Danh Sách Học Viên Trong Lớp ({studentsData.length})
                        </h6>
                    </Col>
                    <Col md={4}>
                        <Form.Control
                            size="sm"
                            type="text"
                            placeholder="Tìm kiếm họ tên, SĐT, CCCD..."
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                        />
                    </Col>
                </Row>
            </Card.Header>
            <Card.Body className="p-0">
                <div className="table-responsive">
                    <Table hover className="mb-0 text-nowrap">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: 50 }}>#</th>
                                <th>Họ và tên</th>
                                <th>Ngày sinh</th>
                                <th>Giới tính</th>
                                <th>Số CCCD/CMND</th>
                                <th>Số điện thoại</th>
                                <th>Nơi sinh / Đơn vị</th>
                                <th>Đối tượng</th>
                                <th>Miễn giảm</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                <tr><td colSpan={9} className="text-center py-4">Đang tải danh sách học viên...</td></tr>
                            ) : filteredStudents.length === 0 ? (
                                <tr><td colSpan={9} className="text-center py-4 text-muted">Không tìm thấy học viên nào.</td></tr>
                            ) : (
                                filteredStudents.map((hv, idx) => (
                                    <tr key={hv.id}>
                                        <td>{idx + 1}</td>
                                        <td className="font-weight-bold text-dark">{hv.hoTen}</td>
                                        <td>{hv.ngaySinh ? moment(hv.ngaySinh).format('DD/MM/YYYY') : "—"}</td>
                                        <td>{getGioiTinhBadge(hv.gioiTinh)}</td>
                                        <td>{hv.soCccd || "—"}</td>
                                        <td>{hv.soDienThoai || "—"}</td>
                                        <td>{hv.noiSinh || "—"}</td>
                                        <td>
                                            <Badge variant="primary">
                                                {hv.doiTuong === 1 ? "Quân" : hv.doiTuong === 2 ? "Khác" : "Quân & Dân"}
                                            </Badge>
                                        </td>
                                        <td>
                                            {hv.isDoiTuongMienGiam ? (
                                                <Badge variant="success">Miễn giảm</Badge>
                                            ) : (
                                                <span className="text-muted">—</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
        </Card>
    );
};

export default StudentLienTucTab;
